import { invoiceApi } from '../firebase/functionsService';

// Henter faktura-PDF fra serveren og starter nedlasting i nettleseren.
export async function downloadInvoicePdf(invoiceId) {
  const { filename, base64 } = await invoiceApi.getInvoicePdf(invoiceId);
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'faktura.pdf';
  document.body.appendChild(a);
  try {
    a.click();
  } finally {
    document.body.removeChild(a);
    // Gi nettleseren tid til å starte nedlastingen før URL-en frigjøres.
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }
}
